"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3scale = require("d3-scale");
var _1 = require(".");
var dateUtils_1 = require("../../dateUtils");
var Accessor_1 = require("../../models/Accessor");
var metricValue_1 = require("../metricValue");
/**
 * Creates a function which will extend static threshold lines from the definition
 * through the right margin in card views.
 *
 * In any points added, the column pointed to by the `measure` feature will be
 * explicitly set to `null` to indicate that it should be rendered with no
 * value, rather than dropped.
 *
 * @param def The `EffectiveDefinition` to use
 * @returns A function to be called with `totalWidth`, `rightMargin`, and the table to extend
 */
exports.makeVisualTableExtender = function (def) {
    var columnsToExtend = exports.columnsToExtendThroughRightMargin(def);
    var timestampColumn = metricValue_1.getTimestampFeature(def.features);
    var columnsToNull = [metricValue_1.getMeasureFeature(def.features)];
    return function (totalWidth, rightMargin, table) {
        var spec = {
            totalWidth: totalWidth,
            rightMargin: rightMargin,
            timestampColumn: timestampColumn,
            columnsToExtend: columnsToExtend,
            columnsToNull: columnsToNull,
        };
        return exports.extendThroughRightMargin(spec, table);
    };
};
/**
 * Modifies a table by adding a new point to the end, such that the appearance
 * of a right margin is maintained for the primary line, while extending the
 * latest values of the given `columnsToCopy` through the margin.
 *
 * @param spec The specification to use
 * @param table The table to extend
 * @returns The modified table
 */
exports.extendThroughRightMargin = function (spec, table) {
    var _a, _b;
    var timeDomain = dateUtils_1.getDateRange(table, Accessor_1.accessorForReference(spec.timestampColumn));
    if (!timeDomain) {
        return table;
    }
    if (spec.rightMargin === 0) {
        return table;
    }
    var timeScale = d3scale
        .scaleLinear()
        .domain([(_a = timeDomain) === null || _a === void 0 ? void 0 : _a.first, (_b = timeDomain) === null || _b === void 0 ? void 0 : _b.last])
        .range([0, spec.totalWidth - spec.rightMargin]);
    var timestamp = timeScale.invert(spec.totalWidth);
    var latestPoint = table[table.length - 1];
    var pointToAdd = generatePointToAdd(latestPoint, spec, timestamp);
    return __spreadArrays(table, [pointToAdd]);
};
exports.shouldExtendThroughRightMargin = function (definition) {
    return _1.isDefaultLineStaticRefLine(definition);
};
exports.columnsToExtendThroughRightMargin = function (definition) {
    var _a;
    var feature = _1.getThresholdFeature(definition.features);
    var comparisonMeasureColumnRef = (_a = _1.getDefaultLineForThreshold(feature)) === null || _a === void 0 ? void 0 : _a.measure;
    return exports.shouldExtendThroughRightMargin(definition) ? [comparisonMeasureColumnRef] : [];
};
var generatePointToAdd = function (latestPoint, spec, timestamp) {
    var _a;
    var _b, _c;
    var refToRefAndValue = function (ref) { return ({
        ref: ref,
        value: ref ? Accessor_1.accessorForReference(ref)(latestPoint) : undefined,
    }); };
    var writeValueToRow = function (row, _a) {
        var ref = _a.ref, value = _a.value;
        if (ref && value !== undefined) {
            row[ref.column] = value;
        }
        return row;
    };
    var refsWithNullValues = (_c = (_b = spec.columnsToNull) === null || _b === void 0 ? void 0 : _b.map(function (ref) { return ({ ref: ref, value: null }); }), (_c !== null && _c !== void 0 ? _c : []));
    var copiedValues = spec.columnsToExtend
        .map(refToRefAndValue)
        .concat(refsWithNullValues)
        .reduce(writeValueToRow, {});
    var pointToAdd = __assign(__assign({}, copiedValues), (_a = {}, _a[spec.timestampColumn.column] = new Date(timestamp), _a));
    return pointToAdd;
};
//# sourceMappingURL=extendThroughRightMargin.js.map